import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL } from "../../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  InputRow,
  PageHeader,
  Section,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.VoiceShowInventoryMessage,
  LocationVarKey.VoiceSendShowInventoryText,
  LocationVarKey.VoiceShowInventoryTextMessage,
  LocationVarKey.VoiceForwardShowInventory,
  LocationVarKey.VoiceShowInventoryEscalateTo,
  LocationVarKey.VoiceShowInventoryPhoneNumber
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page}>Rent a Unit</PageHeader>
      <TextAreaRow {...page} marginTop label=" Voice Message" keyName={LocationVarKey.VoiceShowInventoryMessage} />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceSendShowInventoryText} label="Send SMS" />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceSendShowInventoryText, "1")}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.VoiceShowInventoryTextMessage}
      />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceForwardShowInventory} label="Escalate" />
      <DropdownRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.VoiceForwardShowInventory, "0")}
        label="Send escalations to"
        marginTop
        keyName={LocationVarKey.VoiceShowInventoryEscalateTo}
        options={[
          { label: "swivl Conversations", value: "swivl" },
          { label: "External Phone Number", value: "phone" }
        ]}
      />
      <Section
        {...page}
        hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.VoiceForwardShowInventory, "1"), IS_EQUAL(LocationVarKey.VoiceShowInventoryEscalateTo, "swivl")])}
      >
        <InputRow {...page} keyName={LocationVarKey.VoiceShowInventoryPhoneNumber} label="External Phone Number" />
        <div className="cortexDescription">
          This is the direct line defined{" "}
          <a
            href="/properties/page/cortex/voice/voice-settings"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#FF5B02", textDecoration: "underline" }}
          >
            here
          </a>
          . Only overwrite this if you have a different direct line for this use case!
        </div>
      </Section>
    </>
  );
}
